var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServiceExclamatory(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#FEE6A1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6964 10.1383L21.3888 23.6176H18.3872L18.0889 10.1383H21.6964ZM19.888 29.4343C19.3224 29.4343 18.8377 29.2355 18.4338 28.8377C18.036 28.44 17.8372 27.9553 17.8372 27.3835C17.8372 26.8242 18.036 26.3457 18.4338 25.948C18.8377 25.5503 19.3224 25.3514 19.888 25.3514C20.4411 25.3514 20.9196 25.5503 21.3235 25.948C21.7337 26.3457 21.9387 26.8242 21.9387 27.3835C21.9387 27.7626 21.8424 28.1075 21.6498 28.4183C21.4633 28.729 21.2148 28.9776 20.904 29.164C20.5995 29.3442 20.2608 29.4343 19.888 29.4343Z",
    fill: "#111927"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceExclamatory);
export default __webpack_public_path__ + "static/media/ServiceExclamatory.485bbe39b0832d85b3bb8b9a6ed51326.svg";
export { ForwardRef as ReactComponent };